import I18N from '@leverege/i18n';
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.dataViewers.layout.SaveLayoutAction');
export default {
  id: 'molten.dataViewers.layout.SaveLayoutAction',
  name: tf('name'),
  matches: {
    use: ['layoutActionBar', 'headerOptions']
  },
  handles: context => {
    const layout = context?.layout || context?.clientState?.actionsContext?.layout || {};
    return layout.modifiedLayout != null;
  },
  layout: {
    sort: 'a.c2'
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('confirm', 'fa fa-check fa-fw'),
      variant: 'confirm'
    };
  },
  perform: ({
    context
  }) => {
    const layout = context?.layout || context?.clientState?.actionsContext?.layout || {};
    const {
      layoutGroup,
      layoutVersion,
      onLayoutSave,
      modifiedLayout,
      customSettingsPath
    } = layout;
    if (layoutGroup) {
      onLayoutSave({
        layoutGroup,
        name: layoutVersion.name,
        value: modifiedLayout
      });
    } else {
      onLayoutSave({
        saveToCustomLayout: true,
        value: modifiedLayout,
        customSettingsPath
      });
    }
  }
};